import { Injectable } from '@angular/core';
import { FormGroup, ValidatorFn, Validators } from '@angular/forms';
import {
  NAME_PATTERNS,
  REG_EXP,
  extractMaxLength
} from '@com-delta-idp/mnx-sitewide-shared-utils';
import {
  CheckInWidget,
  CheckInWidgetFormType
} from '../models/check-in-widget.interfaces';

@Injectable({
  providedIn: 'root'
})
export class CheckInFormValidatorService {
  getLastNameValidators(
    content: CheckInWidget,
    hideLastName: boolean
  ): ValidatorFn[] {
    const maxLengthValue = Number(
      extractMaxLength(NAME_PATTERNS.LAST_NAME_REGEX)
    );
    const maxLength = content.nameLengthConfig ? maxLengthValue : 50;
    const pattern = content.nameLengthConfig
      ? NAME_PATTERNS.LAST_NAME_REGEX
      : REG_EXP.LAST_NAME;

    const baseValidators = [
      Validators.maxLength(maxLength),
      Validators.pattern(pattern)
    ];

    return hideLastName
      ? baseValidators
      : [Validators.required, ...baseValidators];
  }

  clearFormFields(form: FormGroup<CheckInWidgetFormType>): void {
    form.markAsUntouched();
  }

  updateValidators(
    form: FormGroup<CheckInWidgetFormType>,
    fieldName: string,
    validators: ValidatorFn[]
  ): void {
    form.get(fieldName)?.setValidators(validators);
    form.get(fieldName)?.updateValueAndValidity();
  }
}
